import React from 'react';
import {
  OrderedTextStyle,
  PropertiesDivStyle,
  PropertyCardStyle,
  PropertyCardWrapper,
  PropertyContentStyle,
  PropertySpanStyle,
  PropertyTextStyle,
} from './LegacyStyles';
import { LegacyOrder, LegacyOrderProperty } from '../../types';

interface Props {
  legacyOrder: LegacyOrder;
}

const PropertiesSlideout = (props: Props) => {
  return (
    <React.Fragment>
      <PropertiesDivStyle>
        <div style={{ marginTop: 30, marginBottom: 15 }}>
          <OrderedTextStyle style={{ marginRight: 8 }}>
            Properties{' '}
          </OrderedTextStyle>
          {/* <button onClick={() => onShowPropertiesClick()}> {props.openProperties ? <ArrowForwardLegacyOrders /> : <ArrowBackwardLegacyOrders /> } </button> */}
        </div>

        {props.legacyOrder.properties.map(
          (p: LegacyOrderProperty, idx: number) => {
            return (
              <PropertyCardWrapper>
                <PropertyCardStyle>
                  <div style={{ marginBottom: 20 }}>
                    <span
                      style={{
                        color: '#BCC2C7',
                        fontWeight: 'bold',
                        fontSize: 10,
                      }}
                    >
                      PROPERTY {idx + 1}
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: 14,
                        marginLeft: 32,
                      }}
                    >
                      {p.address}
                    </span>
                    <br />
                  </div>

                  <PropertyContentStyle>
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <PropertySpanStyle style={{ width: 80 }}>
                        Municipality
                      </PropertySpanStyle>
                      <PropertyTextStyle>{p.municipality}</PropertyTextStyle>
                    </div>
                    <div>
                      <PropertySpanStyle>SBL</PropertySpanStyle>
                      <PropertyTextStyle>
                        {p.section}-{p.block}-{p.lot}
                      </PropertyTextStyle>
                    </div>
                  </PropertyContentStyle>
                  <PropertyContentStyle>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      <PropertySpanStyle style={{ width: 80 }}>
                        County
                      </PropertySpanStyle>
                      <PropertyTextStyle>{p.county}</PropertyTextStyle>
                    </div>
                  </PropertyContentStyle>
                </PropertyCardStyle>
              </PropertyCardWrapper>
            );
          }
        )}
      </PropertiesDivStyle>
    </React.Fragment>
  );
};
export default PropertiesSlideout;
